<template>
  <div class="apple-care-card-container">
    <ProductConfigurationItem :product="data" :label="data.name">
      <template v-slot:slotProductTitle>
        ปกป้องผลิตภัณฑ์ Apple ของคุณ
      </template>

      <template v-slot:slotProductPrice>
        <div v-if="isDelivery">
          <span> ฿{{ data.price_ship | currency }} </span>
          <span v-if="showSrp" class="srp-pricing text-line-through">
            ฿{{ data.price_srp | currency }}
          </span>
        </div>
        <div v-else-if="isStore">
          <span> ฿{{ data.price_store | currency }} </span>
          <span v-if="showSrp" class="srp-pricing text-line-through">
            ฿{{ data.price_srp | currency }}
          </span>
        </div>
      </template>

      <template v-slot:slotProductInfoAction>
        <v-btn
          :color="isBnn ? '#eba614' : 'primary'"
          :ripple="false"
          plain
          width="fit-content"
          height="fit-content"
          class="btn-link"
          @click.stop="$emit('learn-more', data)"
        >
          เรียนรู้เพิ่มเติม <v-icon>mdi-chevron-right</v-icon>
        </v-btn>
      </template>

      <template v-slot:slotProductAction>
        <v-btn
          :class="[
            'btn btn-apple-care-toggle mt-md-0 mt-3',
            { selected: select },
          ]"
          block
          depressed
          color="primary"
          :outlined="!isBnn"
          @click.stop="$emit('click')"
        >
          <template v-if="!select">
            เพิ่ม
          </template>
          <template v-else>
            เพิ่มแล้ว
          </template>
        </v-btn>
      </template>
    </ProductConfigurationItem>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import isBnn from '@/config/isBnn'

export default {
  components: {
    ProductConfigurationItem: () =>
      import('@/components/studio7/ProductConfigurationItem.vue'),
  },

  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
    select: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      isBnn,
    }
  },

  computed: {
    ...mapState({
      cartDelivery: state => state.cart.delivery,
    }),

    isDelivery() {
      return this.cartDelivery === 'delivery'
    },

    isStore() {
      return this.cartDelivery === 'store'
    },

    showSrp() {
      if (this.isDelivery) {
        return this.data.price_ship !== this.data.price_srp
      }
      if (this.isStore) {
        return this.data.price_store !== this.data.price_srp
      }
      return false
    },
  },
}
</script>

<style lang="stylus" scoped>
.apple-care-card-container
  width: 100%
  height: 100%
  display: flex
  flex-direction: column
  box-sizing: border-box;

::v-deep .product-configuration-container
  flex: 1

.srp-pricing
  color: rgba(0, 0, 0, 0.45)
  margin-left: 8px

.text-line-through
  text-decoration: line-through

.btn-link
  padding: 0 !important

.btn-apple-care-toggle
  font-weight: bold
</style>
